export class Service {
  constructor(service) {
    this.id = service.id;
    this.name = service.name;
    this.price = service.price;
    this.show_full = false;
  }

  changeStatusShowFull() {
    this.show_full = !this.show_full;
  }
}
